import { useQuery } from '@tanstack/react-query'

import { get, post } from '@/services/awsAmplify'

import { ContestCategory, ContestType } from '@enums'

export interface IContestType {
  contestType: ContestType
  rpkPrizePool: number
  resetViewCount: boolean
  submissionStopOnVoting: boolean
  minParticipants: number
  maxParticipants: number
  maxWinners: number
  minVotes: number
  skipStartOffset: boolean
  resetVotes: boolean
  clearContestants: boolean
  numberOfSeasons: number
  submissionStartOffsetTime: number
  contestResultOffsetTime: number
}

export interface IContestConfiguration extends IContestType {
  id?: string
  userId: string
  contestName: string
  contestDescription: string
  challengeVideo: string
  goesOnline: number | null
  numberOfSeasons: number
  contestCategory: ContestCategory
  contestVideoLength: number
  submissionStartOffsetTime: number
  votingStartOffsetTime: number
  contestResultOffsetTime: number
  seasonalVotes: boolean
  createdAt: number | null
}

export const getContestInfo = async (contestId: UUID) => {
  return get({
    path: `/contest/${contestId}`,
  })
}

export const joinContest = async ({
  contestId,
  description,
}: {
  contestId: string
  description: string
}) => {
  const data = await post({
    path: `/contest/${contestId}/participant`,
    params: {
      description,
    },
  })

  return data
}

export const useContestLeaderboard = (contestId: UUID) =>
  useQuery({
    queryKey: ['contestLeaderboard', contestId],
    queryFn: () => getContestLeaderboard(contestId),
  })

export const getContestLeaderboard = async (contestId: UUID) => {
  return get({
    path: `/contests/${contestId}/leaderboard`,
  })
}

export const createContest = async (contest: IContestConfiguration) => {
  const data = await post({
    path: `/contest-configuration`,
    params: {
      ...contest,
    },
  })

  return data
}
